module.exports = __webpack_public_path__ + "img/P17-zh.edfdd0d2.png";